"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deafultDetailTranslate = void 0;
exports.deafultDetailTranslate = {
    forSale: 'For Sale',
    forRent: 'For Rent',
    soleAgent: 'Sole Agent',
    save: 'Save',
    share: 'Share',
    sqft: 'SF',
    sa: 'S',
    gfa: 'G',
    beds: 'Beds',
    baths: 'Baths',
    id: 'Property ID',
    ref: 'Ref',
    updated: 'Updated',
    layout: 'Layout',
    floor: 'Floor',
    floorRise: ' Floor',
    features: 'Features',
    buildingAge: 'Building Age',
    buildingType: 'Building Type',
    facilities: 'Facilities',
    years: 'Years',
    contact: 'Contact',
    contactAgent: 'Contact Agent',
    mapview: 'Map View',
    streetview: 'Street View',
    startvr: 'Start Virtual Tour',
    neighbouthood: 'Neighbourhood',
    myPlaces: 'My Places',
    properties: 'Properties',
    schools: 'Schools',
    more: 'More',
    enterLocation: 'Enter a location (eg. Wyndham Street)',
    min: 'min',
    hour: 'hr',
    saveThisPlace: 'Save this place',
    virtualTour: 'Virtual Tour',
    virtualTourCaption: 'Explore the property in 3D space',
    wantToList: 'Want to list your property with virtual tour?',
    listYourProperty: 'List your property with OKAY.COM',
    mortgage: 'Mortgage',
    propertyValue: 'Property Value',
    downPayment: 'Down Payment',
    duration: 'Tenor',
    hkBuyer: "I'm HK Buyer",
    ownsProperty: "I've own other properties in HK",
    hasTransactedRecently: "This property has transaction in past ",
    month: "month",
    interestRate: 'Interest Rate',
    insurance: 'Insurance',
    customizeCalculation: 'Advanced Calculator',
    monthlyPayment: 'Monthly Payment',
    totalCashOutlay: 'Total Cash Outlay',
    explore: 'Explore',
    avg: 'Avg.',
    viewDetails: 'View Details',
    similarProperties: 'Nearby Properties at similar prices',
    districtGuide: 'District Guide',
    featureAndFacilities: 'Features & Facilities',
    viewMore: 'View More',
    custom: 'Custom',
    yrs: 'yrs',
    perMonth: '/mo',
    keepUpdateWith: 'Keep update with',
    follow: 'Follow',
    searchProperties: 'Search these properties',
    vr: 'Virtual Tour',
    photo: 'Photos',
    floorPlan: 'Floor Plan',
    streetView: 'Street View',
    addPlace: 'Add new place',
    results: 'Results',
    direction: 'Direction',
    view: 'View',
    bd: 'BD',
    ba: 'BA',
    savedPlaces: 'Saved Places',
    followings: 'Followings',
    history: 'History',
    essentials: 'Essentials',
    banksAtm: 'Banks / ATM',
    hospital: 'Hospitals',
    commute: 'Commute',
    railwaysMtr: 'Railways / MTR',
    busStop: 'Bus Stops',
    lifestyle: 'Lifestyle',
    restaurant: 'Restaurant',
    convenienceStores: 'Convenience Stores',
    nearbyProperties: 'Nearby Properties',
    noSavedPlaceYet: 'No Saved Places Yet.',
    startAddingNewPlace: 'Start adding a new Place',
    getTravelTime: 'Get Travel Time',
    startSavingNewPlace: 'Start saving a new place by Logging in',
    login: 'Login',
    hkd: 'HK$',
    principlePlaceholder: 'eg. 8,000,000',
    downPaymentPlaceholder: 'eg. 1,000,000',
    downPaymentPercentPlaceholder: 'eg. 50%',
    durationPlaceholder: 'eg. 25',
    interestPlaceholder: 'eg. 2%',
    percent: '%',
    interest: 'Interest',
    stampDuty: 'Stamp Duty',
    commission: 'Commission',
    totalExpense: 'Total Expenses',
    calculate: 'Calculate',
    overview: 'Overview',
    schedule: 'Schedule',
    rateTable: 'Rate Table',
    minimumIncome: 'Minimum Income',
    totalExpenseBreakdown: 'Total Expenses Breakdown',
    principle: 'Principle',
    total: 'Total',
    mortgageSummary: 'Mortgage Summary',
    monthlyExpense: 'Monthly Expenses',
    assumedIntrestRate: 'Assumed Interest Rate',
    stressTest: 'Stress Test',
    initialTotalCashOutlay: 'Initial Total Cash Outlay',
    noMonth: '# Month',
    payment: 'Payment',
    balance: 'Balance',
    year: 'Year',
    saved: 'Saved',
    unfollow: 'Unfollow',
    unavailbleKey: 'Unavailable',
    unavailbleValue: 'Aiya! This property is no longer available. To search for available properties. Click here',
    unavailbleLink: '#hi',
    findOutMoreAbout: 'Find out more about',
    message: 'Contact',
    subjectToOffer: 'Subject to offer',
    interactiveMap: 'Expand',
    mortgageDisclaimer: 'DISCLAIMER: The calculated value is based on assumptions and provides an approximate result for your reference only.',
    whatsappText: 'I\'m interested in %s - ref# %s. %s You may call me ...',
    addPlaceKeyword: 'Keyword (eg. Wyndham Street)',
    addPlaceNoResults: 'No results. Did you mispell the keyword?',
    noPhoto: 'No photos yet',
    viewPropreties: 'View Properties',
    excludeManagementFee: 'excl.',
    includeManagementFee: 'incl.',
    carparks: 'Carpark(s)',
    covered: 'Covered',
    uncovered: 'Uncovered',
    excludeCarpark: 'excl.',
    includeCarpark: 'incl.',
    favorites: 'Favorites',
    noResults: 'No results',
    forSaleRent: 'For Sale and Rent',
    sameBuildingProperties: 'Available listings in this building',
    video: 'Video',
    back: 'Back To The Property',
    floorPlanDisclaimer: 'Disclaimer: Please note this floor plan has been prepared based on information provided by sources we deem reliable. While efforts have been made to ensure its accuracy. OKAY.com makes no guarantee, warranty or representation as to its accuracy and completeness.',
    sold: 'Sold'
};
